module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "history-box"
  }, [_c('md-card', {
    staticClass: "history-box-content"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Recent Changes")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3218c317","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/dashboard/history-box.vue
// module id = 645
// module chunks = 2